import BigNumber from 'bignumber.js'

const LOCALE = 'en'
const FORMAT_KEY_MAP = {
  0: [0, 0],
  max: [0, 8],
  max0: [0, 0],
  max2: [0, 2],
  max8: [0, 8],
  fc: [2, 2], // fiat currency
  vc: [8, 8], // virtual currency
  default: [2, 2]
}

export function isValidNumber(n) {
  return /^\d*\.?\d*$/.test(n)
}

export default function numberFormat(value, config) {
  if (typeof value === 'string') {
    value = Number(value.replace(/[,%()]/g, ''))
  }

  if (!BigNumber(value).isFinite()) {
    const defaultValue = config && config.defaultValue
    if (!BigNumber(defaultValue).isFinite()) {
      return defaultValue
    }
    value = defaultValue
  }

  const formatKey = String(config?.formatKey ?? config)
  const style = config.accounting ? 'currency' : 'decimal'
  const signDisplay = config.signDisplay ? 'exceptZero' : 'auto'
  const currencySign = config.accounting ? 'accounting' : 'standard'
  const notation = config.compact ? 'compact' : 'standard'
  const roundMode = BigNumber[config.roundMode] || BigNumber.ROUND_DOWN
  const [minimumFractionDigits, maximumFractionDigits] =
    FORMAT_KEY_MAP[formatKey] ||
    (BigNumber(formatKey).isFinite()
      ? [Number(formatKey), Number(formatKey)]
      : FORMAT_KEY_MAP.default)
  // console.log(minimumFractionDigits, maximumFractionDigits, formatKey, BigNumber(formatKey).isFinite() ? [Number(formatKey), Number(formatKey)] : '??')
  const d = BigNumber(value).dp(maximumFractionDigits, roundMode).toString()

  const result = new Intl.NumberFormat(LOCALE, {
    style,
    signDisplay,
    currency: 'USD',
    currencySign,
    notation,
    minimumFractionDigits,
    maximumFractionDigits
  }).format(d)

  return config.accounting ? result.replace(/(\$)/, '') : result
}
